var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal fade", attrs: { tabindex: "-1" } }, [
    _c("div", { staticClass: "modal-dialog" }, [
      _c("div", { staticClass: "modal-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "col-xs-3", attrs: { for: "resultsPerPage" } },
                [_vm._v("Results per page:")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-xs-9" },
                [
                  _c("SelectPicker", {
                    attrs: {
                      "data-id": "resultsPerPage",
                      "data-name": "resultsPerPage",
                      hideEmpty: "",
                      options: _vm.pageSizeOptions,
                    },
                    model: {
                      value: _vm.pageSize,
                      callback: function ($$v) {
                        _vm.pageSize = $$v
                      },
                      expression: "pageSize",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "col-xs-3", attrs: { for: "sampleSize" } },
                [_vm._v("Sample size:")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-9" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("SelectPicker", {
                      staticClass: "input-group-btn",
                      attrs: {
                        "data-id": "sampleMode",
                        "data-name": "sampleMode",
                        "data-menu-width": "grow",
                        hideEmpty: "",
                        options: _vm.sampleModeOptions,
                      },
                      on: { input: _vm.focusSampleSize },
                      model: {
                        value: _vm.sampleMode,
                        callback: function ($$v) {
                          _vm.sampleMode = $$v
                        },
                        expression: "sampleMode",
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.sampleSize,
                          expression: "sampleSize",
                          modifiers: { lazy: true },
                        },
                      ],
                      ref: "sampleSize",
                      staticClass: "form-control",
                      attrs: {
                        id: "sampleSize",
                        name: "sampleSize",
                        placeholder: "sample size",
                        type: "number",
                      },
                      domProps: { value: _vm.sampleSize },
                      on: {
                        change: function ($event) {
                          _vm.sampleSize = $event.target.value
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "col-xs-3", attrs: { for: "sampleSeed" } },
                [_vm._v("Seed:")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.sampleSeed,
                      expression: "sampleSeed",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "sampleSeed",
                    name: "sampleSeed",
                    placeholder: "seed",
                    type: "number",
                  },
                  domProps: { value: _vm.sampleSeed },
                  on: {
                    change: function ($event) {
                      _vm.sampleSeed = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                { staticClass: "col-xs-3", attrs: { for: "wordsAroundHit" } },
                [_vm._v("Context size:")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.wordsAroundHit,
                      expression: "wordsAroundHit",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "wordsAroundHit",
                    name: "wordsAroundHit",
                    placeholder: "Context size",
                    type: "number",
                  },
                  domProps: { value: _vm.wordsAroundHit },
                  on: {
                    change: function ($event) {
                      _vm.wordsAroundHit = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.debug.debug_visible || _vm.debug.debug
            ? _c("div", { staticClass: "checkbox-inline" }, [
                _c(
                  "label",
                  { staticClass: "text-muted", attrs: { for: "debug" } },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.debug.debug,
                          expression: "debug.debug",
                        },
                      ],
                      attrs: { type: "checkbox", id: "debug", name: "debug" },
                      domProps: {
                        checked: Array.isArray(_vm.debug.debug)
                          ? _vm._i(_vm.debug.debug, null) > -1
                          : _vm.debug.debug,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.debug.debug,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.debug, "debug", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.debug,
                                  "debug",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.debug, "debug", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" Debug info"),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Global settings")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkbox-inline" }, [
      _c("label", { attrs: { for: "wide-view" } }, [
        _c("input", {
          attrs: {
            type: "checkbox",
            id: "wide-view",
            name: "wide-view",
            "data-persistent": "",
            checked: "",
          },
        }),
        _vm._v(" Wide View"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: {
            type: "button",
            name: "closeSettings",
            "data-dismiss": "modal",
          },
        },
        [_vm._v("Close")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }